import { FormContent, SummaryItem } from '../../components/bookingConfirmationCard/bookingConfirmationFun';
import { useEffect, useState } from 'react';
import './bookingConfirmation.css';
import BookingConfirmationCard from '../../components/bookingConfirmationCard/bookingConfirmationCard';
import TitleBar from '../../components/titleBar/titleBar';
// import holidayImage from '../../assets/images/trvto_holiday.png';
import tripImage from '../../../assets/images/trvto_trip.png';
import { ReactComponent as Download } from '../../../assets/icons/trvto_download.svg';
import { getHikedPrice, getTaxAmount } from '../../utils/getAmountWithTransaction';
import { getFormattedDate } from '../../utils/formatDate';
import logo from '../../../assets/images/trvto-logo.png';

const BookingConfirmation = () => {
    const [bookingData, setBookingData] = useState({});
    const [userData, setUserData] = useState([]);
    const [bookingId, setBookingId] = useState('');
    const [paymentType, setPaymentType] = useState('');

    useEffect(() => {
        const storedData = localStorage.getItem('bookingData1');
        if (storedData) {
            setBookingData(JSON.parse(storedData));
        }
        const storedUserData = localStorage.getItem('userData1');
        if (storedUserData) {
            setUserData(JSON.parse(storedUserData));
        }
        setPaymentType(localStorage.getItem('paymentType'));
        const storedBookingId =
            localStorage.getItem('bookingId') || JSON.parse(localStorage.getItem('bookedData')).bookingId;
        if (storedBookingId) {
            setBookingId(storedBookingId);
        }
    }, []);
    return (
        <div style={{ marginTop: '70px' }}>
            <TitleBar title='Booking Confirmed' />
            <div className='manageOrder mb-2'>
                <div className='customContainer'>
                    <div className='cardContainer'>
                        <div className='printOnly'>
                            <img src={logo} alt='trvto logo' className='headerLogoImg'></img>
                        </div>
                        <BookingConfirmationCard
                            title='Your Trip'
                            imgSrc={localStorage.getItem('tripImage') || tripImage}
                            imgAlt='trvto_trip'
                            tripName={bookingData?.title}
                        >
                            <FormContent
                                label='Trip Date'
                                answer={getFormattedDate(new Date(bookingData?.date || bookingData.startDate))}
                            />
                            <div className='innerFormContent'>
                                <FormContent label='Organizer Name' answer={bookingData?.organizerName} />
                                <FormContent label='Travelers' answer={bookingData?.people} />
                                <FormContent label='Days' answer={bookingData?.days} />
                                <FormContent label='Name' answer={userData[0]?.name} />
                                <FormContent label='Phone' answer={userData[0]?.phoneNumber} />
                                <FormContent label='Email' answer={userData[0]?.emailId} />
                                <FormContent label='Transport' answer={bookingData?.transport} />
                                {bookingData.datesType === 'fixed' && bookingData.totalRooms > 0 ? (
                                    <FormContent label='Rooms' answer={bookingData?.totalRooms} />
                                ) : (
                                    bookingData?.customTrip?.rooms?.length > 0 && (
                                        <FormContent label='Rooms' answer={bookingData?.customTrip?.rooms?.length} />
                                    )
                                )}
                                {Number(bookingData?.customTrip?.bed || 0) > 0 && (
                                    <FormContent label='Extra Beds' answer={bookingData?.customTrip?.bed} />
                                )}
                                {bookingData?.customTrip?.vehicle?.length > 0 && (
                                    <FormContent
                                        label='Vehicle'
                                        answer={bookingData.customTrip?.vehicle
                                            .map((v) => `${v.vehicleName}: ${v.vehicleCount}`)
                                            .join(', ')}
                                    />
                                )}
                                {bookingData.group === 'vehicle' && (
                                    <>
                                        <FormContent label='Vehicle' answer={bookingData?.vehicle?.mode} />
                                        {bookingData?.vehicle?.model && (
                                            <FormContent label='Vehicle Model' answer={bookingData?.vehicle?.model} />
                                        )}
                                        {bookingData?.vehicle?.comfortable === 'Yes' && (
                                            <FormContent
                                                label='Empty Seats'
                                                answer={bookingData?.vehicle?.emptySeats}
                                            />
                                        )}
                                    </>
                                )}
                                <FormContent label='Start City' answer={bookingData?.startCity} />
                                <FormContent
                                    label='Pickup/Meetup Location'
                                    answer={bookingData?.pickupLocation || bookingData?.meetupPoint}
                                />
                                <FormContent label='Booking ID' answer={bookingId} />
                            </div>
                        </BookingConfirmationCard>
                        <div className='card rightCard'>
                            <p className='title font24'>Summary</p>
                            <div className='summaryContent'>
                                {bookingData?.isReserved ||
                                bookingData?.isInstallment ||
                                bookingData?.amountPaid?.isReserved ||
                                bookingData?.amountPaid?.isInstallment ? (
                                    <>
                                        <SummaryItem
                                            label='Sub Total'
                                            amount={`₹${(bookingData.totalAmo || bookingData.amountPaid.paid) - (paymentType === 'UPI' ? 0 : bookingData?.convinienceFee)}`}
                                        />
                                        <SummaryItem
                                            label='Convinience Fee'
                                            amount={`+ ₹${bookingData?.convinienceFee}`}
                                        />
                                        {paymentType === 'UPI' && (
                                            <SummaryItem
                                                label='UPI Offer'
                                                amount={`- ₹${bookingData?.convinienceFee}`}
                                            />
                                        )}
                                    </>
                                ) : (
                                    <>
                                        <SummaryItem
                                            label='Sub Total'
                                            amount={`₹${
                                                Math.round(
                                                    (bookingData?.actualPrice * bookingData?.people * 100) / 80
                                                ) || getHikedPrice(bookingData?.amountPaid?.actual)
                                            }`}
                                        />
                                        {!bookingData.isReserved &&
                                            !bookingData.isInstallment &&
                                            bookingData.room > 0 && (
                                                <SummaryItem
                                                    label='Room'
                                                    amount={`+ ₹${bookingData?.room * bookingData?.roomAmount} `}
                                                />
                                            )}
                                        <SummaryItem
                                            label='Discount'
                                            amount={`- ₹${
                                                Math.round(
                                                    ((bookingData?.actualPrice * bookingData?.people * 100) / 80) * 0.2
                                                ) || Math.round(getHikedPrice(bookingData?.amountPaid?.actual) * 0.2)
                                            }`}
                                        />

                                        {(bookingData?.offerAmo > 0 || bookingData?.amountPaid?.offerAmount > 0) && (
                                            <SummaryItem
                                                label='Offer'
                                                amount={`- ₹${bookingData?.offerAmo || bookingData?.amountPaid?.offerAmount}`}
                                            />
                                        )}
                                        <SummaryItem
                                            label='Convinience Fee'
                                            amount={`+ ₹${bookingData?.convinienceFee}`}
                                        />
                                        {paymentType === 'UPI' && (
                                            <SummaryItem
                                                label='UPI Offer'
                                                amount={`- ₹${bookingData?.convinienceFee}`}
                                            />
                                        )}
                                        {!bookingData.isReserved && !bookingData.isInstallment && (
                                            <SummaryItem
                                                label='Tax'
                                                amount={`+ ₹${bookingData?.amountPaid?.tax || getTaxAmount(bookingData?.peopleAmo || bookingData?.amountPaid?.total)} `}
                                            />
                                        )}
                                    </>
                                )}

                                <SummaryItem
                                    label='Total'
                                    amount={`₹${paymentType === 'OTHERS' ? bookingData?.totalAmo : bookingData?.totalAmo || bookingData?.amountPaid?.total}`}
                                    isTotal={true}
                                />
                            </div>
                            <div style={{ marginTop: '20px' }}>
                                {(bookingData.isReserved || bookingData?.amountPaid?.isReserved) && (
                                    <div className='leftAmountDiv'>
                                        Remaining amount to be paid on the trip Rs.{bookingData?.remainingAmount}{' '}
                                        (including tax)
                                    </div>
                                )}
                            </div>
                            <button className='floatingPrintButton hideOnPrint' onClick={() => window.print()}>
                                <Download /> Download
                            </button>
                        </div>
                    </div>
                </div>
                {/* <div className="customContainer" style={{ marginTop: '24px' }}>
                    <div className="cardContainer">
                        <BookingConfirmationCard
                            title="Holiday Packages"
                            imgSrc={holidayImage}
                            imgAlt="trvto_holiday"
                            tripName="Jeju Island"
                            reviews={{ rating: '4.5', count: '237' }}
                        >
                            <FormContent
                                label="Dates"
                                answer="10 August, 2024 - 16 August, 2024"
                            />
                            <div className="innerFormContent">
                                <FormContent
                                    label="Pickup Timings"
                                    answer="11:00 AM"
                                />
                                <FormContent label="Guests" answer="2" />
                            </div>
                            <div className="innerFormContent">
                                <FormContent label="Type" answer="Holiday" />
                                <FormContent label="Stay" answer="5 Days" />
                            </div>
                            <div className="innerFormContent">
                                <FormContent label="Food" answer="Yes" />
                                <FormContent
                                    label="Transport"
                                    answer="Indigo Air"
                                />
                            </div>
                            <FormContent
                                label="Pickup Location"
                                answer="2464 Royal Ln. Mesa, New Jersey 45463"
                            />
                            <FormContent
                                label="Organizer Name"
                                answer="Jaane Cooper"
                                className="borderNone"
                            />
                        </BookingConfirmationCard>
                    </div>
                </div> */}
            </div>
        </div>
    );
};

export default BookingConfirmation;
